import { useMemo } from 'react'
import { usePlaceByName, useResolvedPlaceIdentity } from 'hooks/usePlace'
import { getPlaceByRegionCode } from 'constants/places'

interface TypesPageUserPlace {
  userPlace: App.Place | undefined
  fallbackPlaceId: string
}

export default function useTypesPageUserPlace(regionCode: string, geoStateName: string | undefined): TypesPageUserPlace {
  const geoStatePlace = usePlaceByName(geoStateName)
  const regionPlaceIdentity = useMemo(() => getPlaceByRegionCode(regionCode), [regionCode])
  const resolvedRegionPlace = useResolvedPlaceIdentity(regionPlaceIdentity)

  const userPlace = useMemo(() => {
    if (regionCode === 'AU' && geoStatePlace) {
      return geoStatePlace
    }
    return resolvedRegionPlace
  }, [geoStatePlace, regionCode, resolvedRegionPlace])

  return useMemo(() => ({
    userPlace,
    fallbackPlaceId: userPlace?.id ?? regionPlaceIdentity.id,
  }), [userPlace, regionPlaceIdentity])
}
